import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {PartnerBannerDgSearchResults} from "../models/datagrid-search-results/partner-banner-dg-search-results.model";
import {PartnerBannersService} from "../providers/partner-banners.service";

@Injectable()
export class PartnerBannersResolve implements Resolve<PartnerBannerDgSearchResults> {
  constructor(private partnerBannersService: PartnerBannersService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PartnerBannerDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.partnerBannersService.getResults(10,0,'ASC','created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
